import styled from "styled-components";
import { Content } from "_c/Modals";

export const Head = styled.h2`
  margin: 0;
  font-size: 20px;
  text-align: center;
  margin-bottom: 15px;
  font-weight: 700;
  flex-shrink: 0;
`;
export const MainContent = styled(Content)`
  padding: 0 !important;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  flex-shrink: 0;
  padding-top: 10px;
  button {
    margin: 5px;
    margin-bottom: 0;
  }
`;
